import {defineMessages} from 'react-intl';

export default defineMessages({
	itemName: {
		id: 'orders.giftcard.itemName',
		defaultMessage: 'Casadei Gift Card'
	},
	giftcardAmount: {
		id: 'orders.giftcard.amount',
		defaultMessage: 'Amount: {currency} {amount}',
	},
	sentTo: {
		id: 'orders.giftcard.sentTo',
		defaultMessage: 'Sent To: {recipient}'
	},
	email: {
		id: 'orders.giftcard.email',
		defaultMessage: 'At Email: {recipientEmail}'
	}
});
